






































import {Component, Prop, Vue} from "vue-property-decorator";
import {getModule} from "vuex-module-decorators";
import {BaseStore} from "@/store/BaseStore";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {CompanyInfo} from "@/entity/CompanyInfo";

@Component({
  components: {},
})

export default class QingApView extends Vue {
  collectAppName = this.$route.params.collectAppName
  url = this.$route.params.url
  //从监听消息里面拿数据
  bs = getModule(BaseStore)
  su = SecurityUtils;

  watchFlag = 0; // 1是关闭
  watchID: any //gps 连续定位变量
  dynamicHeight = 0


  changeFrameHeight() {
    const iframe = this.$refs.backGround as any
    const a = iframe.style.minHeight.replace("px","")
    this.dynamicHeight = a-10+ 'px' as any
  }

  close() {
    this.watchFlag = 1
    sessionStorage.removeItem('qingAppName');
    this.$router.push({name: 'KeShangSelect'})
  }

  pass() {
    sessionStorage.setItem("goback", "2");
    setTimeout(() => {
      const elementById = document.getElementById("qingAPP") as HTMLIFrameElement;
      // getModule(BaseStore).setYgUrl(elementById.src)
      // elementById.src=getModule(BaseStore).url
      elementById.src = getModule(BaseStore).ebyMessage.url
    }, 100);
  }

  get tab() {
    console.log(this.bs.ebyMessage.tabName)
    return this.bs.ebyMessage.tabName
  }

  get phone() {
    return this.bs.ebyMessage.phone
  }

  get personName() {
    return this.bs.ebyMessage.personName
  }

  goBack() {
    window.history.go(-1);
    // window.history.back();
    sessionStorage.removeItem('qingAppName');
  }

  listenInSigninReady() {
    const url = this.url.substring(0, this.url.indexOf('?'))
    console.log(this.url);
    if (url == 'https://yzksdaka.yong-gang.cn/') {
      // if (url == 'http://192.168.99.133:8081/'){
      window.addEventListener('message', (e) => {
        if (e.data === '签到准备完成') {
          console.log("====================")
          const iFrame = document.getElementById('qingAPP') as any
          // const a = localStorage.getItem("demo1") as any
          // const company = JSON.parse(a)
          const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as  any) as CompanyInfo;
          navigator.geolocation.getCurrentPosition((e: any) => {
            // const a = GPS.gcjEncrypt((e.coords.latitude), (e.coords.longitude))
            iFrame.contentWindow.postMessage("签到数据" + ',' + this.su.getLoginUser().username + ',' + companyInfo.companyId + ',' + companyInfo.companyName + ',' + e.coords.longitude + ',' + e.coords.latitude, '*')
          }, (e: any) => {
            console.log(e)
          });
        }
      })
    }
  }

  async continuousMonitoring() {
    const url = this.url.substring(0, this.url.indexOf('?'))
    if (url == 'https://yzksdaka.yong-gang.cn/') {
      // if (url == 'http://192.168.99.133:8081/'){
      window.addEventListener('message', (e) => {
        if (e.data === '开启连续定位监听') {
          console.log("ppppppppppppppppp")
          const iFrame = document.getElementById('qingAPP') as any
          this.watchID = navigator.geolocation.watchPosition((e: any) => {
            // const a = GPS.gcjEncrypt((e.coords.latitude), (e.coords.longitude))
            iFrame.contentWindow.postMessage("连续监听GPS的数据为" + ',' + e.coords.longitude + ',' + e.coords.latitude, '*')
            if (this.watchFlag == 1) {
              navigator.geolocation.clearWatch(this.watchID);
              this.watchFlag = 0
            }
          }, (e: any) => {
            console.log(e)
          }, {
            enableHighAccuracy: true,
            maximumAge: 0,
            timeout: 5000
          });
        }
      })
    }
  }
  scanForMonitoring(){
    window.addEventListener('message', (e) => {
      if (e.data === '调用APP扫一扫') {
        const win = window as any
        const cordova = win.cordova
        const iFrame = document.getElementById('qingAPP') as any
        cordova.plugins.barcodeScanner.scan((result: any)=>{
          if (!result.cancelled) {
            if (result.text != null && result.text != undefined && result.text != '') {
              iFrame.contentWindow.postMessage("扫一扫的数据为" + ',' + result.text, '*')
            }
          }
        },(error: any)=>{
            iFrame.contentWindow.postMessage("扫一扫报错error" + ',' + error.text, '*')
        },      {
          preferFrontCamera : false, // iOS and Android
          showFlipCameraButton : true, // iOS and Android
          showTorchButton : true, // iOS and Android
          torchOn: true, // Android, launch with the torch switched on (if available)
          saveHistory: true, // Android, save scan history (default false)
          prompt : "在扫描区域内放置条形码", // Android
          resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
          formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
          orientation : "landscape", // Android only (portrait|landscape), default unset so it rotates with the device
          disableAnimations : true, // iOS
          disableSuccessBeep: false // iOS and Android
        })
      }
    })
  }

  private mounted() {
    this.pass()
    this.listenInSigninReady()
    this.continuousMonitoring()
    this.changeFrameHeight()
    this.scanForMonitoring()
  }
}
